import React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout" 
import Header from "../components/header"
import Footer from "../components/sitefooter"

import "../pages/mystyles.scss"


//import { css } from "@emotion/core"
//import styled from "@emotion/styled"

//import { rhythm } from "../utils/typography"



export default ({ data, pageContext }) => {
    const post = data.airtable
    const { previous, next } = pageContext
  return (
    <>
    <Header></Header>
    <Layout></Layout>
    <section class="section">
  <div class="container">

      <h2 class="title is-spaced is-family-secondary">{post.data.Name}</h2>
          
        <div class="subtitle" dangerouslySetInnerHTML={{__html: post.data.Biography}}></div>
        <p><a href={post.data.Artist_s_Website} alt="">{post.data.Artist_s_Website}</a></p>

        <div dangerouslySetInnerHTML={{__html: post.data.Video_Story}}></div>
      <h4 class="subtitle mt-4">works in the database by {post.data.surname}</h4>
        <ul className="LinkedWorks">
{post.data.LinkedWorks.map((item, data, id) =>
<li key={item.id}><Link to={item.data.slashArtworkSlug}>{item.data.Title}</Link></li>


)}
</ul>
      <ul
          style={{
            display: `flex`,
            flexWrap: `wrap`,
            justifyContent: `space-between`,
            listStyle: `none`,
            padding: 0,
          }}
        >
          <li>
            {previous && (
              <Link to={previous.data.slashArtistslug} rel="prev">
                ← {previous.data.Name}
              </Link>
            )}
          </li>
          <li>
            {next && (
              <Link to={next.data.slashArtistslug} rel="next">
                {next.data.Name} →
              </Link>
            )}
          </li>
        </ul>

        </div>
        
        </section>
        <Footer></Footer>
    </>
    )
  
}

export const query = graphql`

    query($artistSlug: String!){
    airtable(data: {slashArtistSlug: {eq: $artistSlug }}) {
  
    data {
      Name
      Biography
      Video_Story
      Artist_s_Website
      surname
      LinkedWorks {
        data {
          Title
          slashArtworkSlug
        }
        id
      }
    }
    
      
    
  }
}
`